/* @flow */
import * as React from 'react';
import Glyph from 'components/Glyph';
import './styles/LinkedAccountSuccessView.scss';

class LinkedAccountSuccessView extends React.Component<{}> {
  render() {
    return (
      <div className="LinkedAccountSuccessView">
        <div className="LinkedAccountSuccessView-wrap">
          <Glyph className="LinkedAccountSuccessView-link" name="link" size="xxlarge" />
          <div className="LinkedAccountSuccessView-title">{'Account successfully linked'}</div>
          <div className="LinkedAccountSuccessView-body">{'You may now close this window'}</div>
        </div>
      </div>
    );
  }
}

export default LinkedAccountSuccessView;
